import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss']
})
export class TileComponent implements OnInit {

    @Input() title: string;
    @Input() imageUrl: string;
    @Input() roles?: string[];
    @Input() redirectUrlAfterClick?: string;
    @Input() count=0;
    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/tile/tile.component.ts